<template>
  <div class="map-wrap">
    <div class="map">
    </div>
  </div>
</template>

<script>
// FIXED: Correct cases used for these inconsistently named libs
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/XYZ'

import Zoom from 'ol/control/Zoom'
import View from 'ol/View'
import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import IconStyle from 'ol/style/Icon'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import GeoJSON from 'ol/format/GeoJSON'

// Load all and group together
import * as Interaction from 'ol/interaction'
import * as Proj from 'ol/proj'

// import Style from 'ol/style/style'
// import Circle from 'ol/style/circle'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'

// App styles for open layers
import 'ol/ol.css'

import WorkMarker from '../assets/maps/m-work.png'
import UserMarker from '../assets/maps/m-user.png'

import forOwn from 'lodash/forOwn'

import BlackoutArea from '../assets/closed-overlay.geojson'

export default {
  name: 'FullMap',
  props: {
    mapopts: {
      type: Object,
      default () {
        return {}
      }
    },
    exhibitGroup: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  computed: {
    nearest () {
      return this.$store.state.nearest
    },
    exhibits () {
      return this.$store.state.exhibits
    }
  },
  methods: {
    updateMapSize () {
      this.map.updateSize()
    },
    go (route) {
      setTimeout(() => {
        this.$router.push(route)
      }, 1)
    },
    addMarkers () {

    },
    createMarkers () {
      this.levelMarkers = {}

      // Loop through exhibits and add or don't according to group membership
      for (var mindex in this.exhibits) {
        if (this.toShow.length > 0 && this.toShow.indexOf(mindex) < 0) {
          continue
        }

        let exhibit = this.exhibits[mindex]

        // If this level has no layer, create one.
        if (!this.levelMarkers.hasOwnProperty(exhibit.level)) {
          this.levelMarkers[exhibit.level] = []
        }

        var marker = new Feature({
          geometry: new Point(Proj.fromLonLat([exhibit.longitude, exhibit.latitude])),
          name: mindex,
          slug: exhibit.friendly,
          level: exhibit.level
        })
        marker.setStyle(new Style({
          image: new IconStyle(/** @type {olx.style.IconOptions} */ ({
            anchor: [0.5, 1],
            src: WorkMarker
          }))
        }))
        this.levelMarkers[exhibit.level].push(marker)
      }

      let levelLayers = {}
      let levelLayerNames = Object.keys(this.levelMarkers)
      for (var markergroups in levelLayerNames) {
        let ml = new VectorLayer({
          source: new VectorSource({
            features: this.levelMarkers[levelLayerNames[markergroups]]
          })
        })
        levelLayers[levelLayerNames[markergroups]] = ml
      }

      return levelLayers
    }
  },
  beforeMount () {
    // Ensure the Locly location API is started
    // window.loclyLocation.start()
  },
  watch: {
    '$store.state.isnight': function (is) {
      this.blackout.setVisible(is)
    },
    '$store.state.user_coords': function (pos) {
      // Move the marker showing the user's position when the Locly API changes the coordinates
      this.userMarker.setGeometry(new Point(Proj.fromLonLat([pos.longitude, pos.latitude])))
    },
    '$store.state.inzone': function (pos) {
      this.updateMapSize()
    },
    'level': function () {
      let level = this.level
      forOwn(this.levellayers, function (v, k) {
        v.setVisible(v.get('level') === level || level === '')
      })
      this.levellayers[this.level].setVisible(!this.levellayers[this.level].getVisible())
    }
  },
  activated () {
    // Ensure that the map is correctly redrawn and scaled when the Vue component is activated
    this.updateMapSize()
  },
  mounted () {
    const vm = this
    // Merge global defaults with specific options
    const defaultSettings = this.$store.state.maps.default
    const mapSettings = Object.assign({}, defaultSettings, this.mapopts)

    // Get the list of exhibits to show if we're only showing a specific group
    this.toShow = this.exhibitGroup ? this.$store.state.exhibit_groups[this.exhibitGroup] : []

    // Create some data from settings and hardcoded defaults
    const mapExtent = Proj.transformExtent(mapSettings.map_extent, 'EPSG:4326', 'EPSG:3857')
    const viewExtent = Proj.transformExtent(mapSettings.view_extent, 'EPSG:4326', 'EPSG:3857')
    const center = mapSettings.center
    const mapMinZoom = mapSettings.min_zoom
    const mapMaxZoom = mapSettings.max_zoom

    // // Get the viewport dimensions
    // const initwinsize = {
    //   width: window.innerWidth || document.body.clientWidth,
    //   height: window.innerHeight || document.body.clientHeight
    // }

    // Create layer list
    const layers = []

    // Include OSM layer if configured
    if (mapSettings.include_osm) { // Show OpenStreetMap tiles too
      layers.push(new TileLayer({
        source: new OSM()
      }))
    }

    // Build main tile layer
    const layer = new TileLayer({
      extent: mapExtent,
      source: new XYZ({
        url: mapSettings.tile_source,
        tilePixelRatio: 1.000000,
        minZoom: mapMinZoom,
        maxZoom: mapMaxZoom
      })
    })
    layers.push(layer)

    const blackout = new VectorLayer({
      title: 'Blackout Area',
      source: new VectorSource({
        projection: 'EPSG:3857',
        format: new GeoJSON(),
        url: BlackoutArea,
        name: 'blackout'
      }),
      style: new Style({
        fill: new Fill({
          color: 'rgba(100, 100, 100, 0.5)'
        })
      })
    })
    blackout.setVisible(this.$store.state.isnight)
    layers.push(blackout)
    this.blackout = blackout

    // Build feature layer
    //  - marker style
    //  - markers
    this.markers = []
    this.userMarker = null

    this.levellayers = this.createMarkers()
    let tllayers = Object.values(this.levellayers)
    for (var tl in tllayers) {
      layers.push(tllayers[tl])
    }

    // Build the user marker
    var userMarker = new Feature({
      geometry: new Point(Proj.fromLonLat([-73.881185, 40.863761])),
      name: 'user'
    })
    userMarker.setStyle(new Style({
      image: new IconStyle(/** @type {olx.style.IconOptions} */ ({
        anchor: [0.5, 1],
        src: UserMarker
      }))
    }))
    this.userMarker = userMarker
    var umLayer = new VectorLayer({
      source: new VectorSource({
        features: [userMarker]
      })
    })
    // layers.push(umLayer)

    // Build our map
    this.map = new Map({
      target: this.$el.querySelector('.map'),
      layers: layers,
      controls: [
        new Zoom()
      ],
      interactions: Interaction.defaults({ altShiftDragRotate: false, pinchRotate: false }),
      view: new View({
        center: Proj.fromLonLat(center),
        zoom: mapSettings.start_zoom,
        // zoom: (initwinsize.width < 1000) ? mapMinZoom : 17,
        minZoom: mapMinZoom,
        maxZoom: mapMaxZoom,
        rotation: 0.55, // 270deg
        extent: viewExtent
      })
    })

    this.map.set('router', this.$router)

    this.map.on('click', function (evt) {
      // Enumerate map features at the click point
      let feature = this.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return feature
      })

      // If the group is 'art' or 'inspiration' show the relevant welcome
      let featname = (feature && feature.get('name')) || ''
      let featslug = (feature && feature.get('slug')) || ''
      /* if (feature && (featname === '72226008-2f67-07b7-e2f4-6b1f67f9bbd7')) {
        vm.go({path: '/inspiration/welcome'})
        return
      }
      if (feature && (featname === '36bc43d6-5c17-162d-d9ec-291fa47b20cd')) {
        vm.go({path: '/art/welcome'})
        return
      } */

      // On click, navigate to the exhibit 'page'
      if (feature && featname !== 'user') {
        vm.go({ name: 'exhibit', params: { exhibitslug: featslug } })
      }
    })

    // Small helper function: map clicks log the latitude and longitude of the click.
    if (mapSettings.click_latlon) {
      this.map.on('click', function (evt) {
        const lonlat = Proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326')
        console.log('Lonlat', lonlat)
      })
    }

    // Set up watcher for Locly user location updates
    // this.$store.watch((state) => state.user_coords, function (oldpos, pos) {
    //   // userMarker.setGeometry(new Point(Proj.fromLonLat([pos.longitude, pos.latitude])))
    // })
  }
}
  </script>

  <style lang="scss" scoped>
    .map-wrap {
      flex: 1;
      position: relative;
      height: 100%;
      width: 100%;
      .map {
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #a4b56e;
      }
    }
  </style>
